import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';

import { IcBackIcon, IcCloseSIcon } from '@gem/icons';
import { customScrollStyles, IconButton } from '@gem/ui-kit';

import { useProfileView } from 'APP/main/ChatView/hooks/profileView/useProfileView';

import styles from './styles.m.css';

const ProfileView = ({ groupId, onClose }) => {
  const scrollNodeRef = useRef(null);
  const profileView = useProfileView({
    groupId,
    onClose,
    scrollNodeRef,
  });

  const Component = profileView.Component;
  const props = profileView.props;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {profileView.hasBackButton && (
          <IconButton
            className={styles.back}
            Icon={IcBackIcon}
            onClick={profileView.goBack}
            size="big"
            iconSize="medium"
          />
        )}
        <h3 className={styles.title}>{profileView.title}</h3>
        <IconButton
          className={styles.close}
          Icon={IcCloseSIcon}
          onClick={profileView.close}
          size="big"
        />
      </div>
      <div
        className={classNames(styles.body, customScrollStyles.container)}
        ref={scrollNodeRef}
      >
        <Component
          className={classNames({
            [styles.profile]: profileView.isProfileOpened,
            [styles.media]: profileView.isSharedDataOpened,
          })}
          {...props}
        />
      </div>
    </div>
  );
};

export default observer(ProfileView);
